import { ComponentProps, FC } from 'react'
import { twMerge } from 'tailwind-merge'
import LoadingImg from '@/icons/LoadingImg'

interface TipsyButtonProps extends ComponentProps<'button'> {
  variant?: 'outlined' | 'filled'
  loading?: boolean
  disabled?: boolean
  color?: string
}

const TipsyButton: FC<TipsyButtonProps> = ({
  children,
  className,
  variant = 'outlined',
  loading = false,
  disabled = false,
  color,
  style,
  ...props
}) => {
  const hoverStyles = 'hover:border-white'
  const disabledStyles = 'cursor-not-allowed border-white/10 text-white/20'

  let variantStyles, disabledVariantStyles
  switch (variant) {
    case 'filled':
      variantStyles = 'bg-white/20'
      disabledVariantStyles = 'bg-white/10'
      break
    case 'outlined':
      variantStyles = 'bg-transparent'
      disabledVariantStyles = ''
      break
    default:
      variantStyles = ''
      disabledVariantStyles = ''
  }

  const mergedStyle = {
    ...(style || {}),
    ...(color && variant === 'filled' ? { backgroundColor: color } : {}),
  }

  return (
    <button
      className={twMerge(
        'relative flex min-h-9 items-center justify-center rounded-full border border-white/50 px-4 text-sm leading-tight',
        variantStyles,
        disabled || loading
          ? twMerge(disabledStyles, disabledVariantStyles)
          : hoverStyles,
        className
      )}
      style={mergedStyle}
      disabled={disabled || loading}
      {...props}
    >
      {/*在这里包一层 span 是为了防止 google 翻译造成应用崩溃*/}
      <span className="absolute inset-0 flex items-center justify-center">
        {loading && <LoadingImg className="scale-[.6]" />}
      </span>
      <span className="flex min-w-0 flex-1 items-center justify-center">
        {!loading && children}
      </span>
    </button>
  )
}

export default TipsyButton
